import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import SalonModal from 'components/dialog/SalonModal.component';
import Button from 'components/form/Button.component';
import Icon from 'components/generic/Icon.component';
import useIsMobileViewport from 'hooks/useIsMobileViewport.hook';
import { useTheme } from 'providers/Theme.provider';

import CN from './DeactivateFormModal.module.scss';

export const DeactivateFormModal = ({ isOpen, onClose, onConfirm, formName }) => {
  const { t } = useTranslation();
  const { isDarkMode } = useTheme();
  const isMobile = useIsMobileViewport();

  return (
    <SalonModal
      tag="DeactivateFormModal"
      isOpen={isOpen}
      shouldCloseOnOverlayClick
      shouldCloseOnEsc
      onClose={onClose}
      fullWidth={!isMobile}
      mode="dark"
      customClass={cn(CN.modalDialog, { [CN.modalDialogDark]: isDarkMode })}
    >
      <SalonModal.Header>
        <div data-bem="DeactivateFormModal__header" className={cn(CN.modalHeader, { [CN.darkMode]: isDarkMode })}>
          <Button variant="icon" tag="DeactivateFormModal__close" className={CN.closeButton} onClick={onClose}>
            <Icon variant="closeDark" width="lg" />
          </Button>
        </div>
      </SalonModal.Header>
      <SalonModal.Body>
        <div className={cn(CN.heading, { [CN.darkMode]: isDarkMode })}>
          <h2 className={CN.title}>{t('consultationForms.deactivateModal.title')}</h2>
          <p className={CN.message}>
            {t('consultationForms.deactivateModal.message')} <span className={CN.deactivateWord}>{t('consultationForms.deactivateModal.deactivate')}</span> <strong>&lsquo;{formName}&rsquo;</strong>
          </p>
          <p className={CN.subMessage}>{t('consultationForms.deactivateModal.subMessage')}</p>
        </div>
      </SalonModal.Body>
      <SalonModal.Footer>
        <Button variant="tertiary" onClick={onClose} tag="DeactivateFormModal__cancel">
          {t('consultationForms.cancel')}
        </Button>
        <Button variant="primary" onClick={onConfirm} tag="DeactivateFormModal__confirm">
          {t('consultationForms.deactivateModal.confirm')}
        </Button>
      </SalonModal.Footer>
    </SalonModal>
  );
};
